module.exports = __webpack_public_path__ + "static/fonts/MontserratItalic.b0cf52e5.ttf";